import { render, staticRenderFns } from "./Slide3.vue?vue&type=template&id=f9ed832a&scoped=true&"
import script from "./Slide3.vue?vue&type=script&lang=js&"
export * from "./Slide3.vue?vue&type=script&lang=js&"
import style0 from "./Slide3.vue?vue&type=style&index=0&id=f9ed832a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9ed832a",
  null
  
)

export default component.exports